import { PencilSimple, TrashSimple } from '@phosphor-icons/react'
import { BubbleMenu, Editor } from '@tiptap/react'
import { Button } from 'antd'
import { MouseEventHandler } from 'react'

export const TooltipLink = ({
  editor,
  handleEdit,
}: {
  editor: Editor
  handleEdit: MouseEventHandler<HTMLButtonElement>
}) => {
  const handleRemoveLink = () => {
    editor.chain().focus().extendMarkRange('link').unsetLink().run()
  }

  const linkHref = editor.getAttributes('link').href

  return (
    <BubbleMenu
      className="border-border-input flex items-center rounded-md border-[0.5px] border-solid bg-white pl-4 pr-2 shadow-sm"
      editor={editor}
      shouldShow={({ editor, from, to }) => {
        return from === to && editor.isActive('link')
      }}
      tippyOptions={{
        placement: 'top',
        maxWidth: 425,
        zIndex: 2,
      }}
    >
      <a
        className="my-2 max-w-[325px] truncate"
        href={linkHref}
        rel="noreferrer"
        target="_blank"
      >
        {linkHref}
      </a>
      <div className="m-0 ml-3 mr-2 h-6 w-[0.5px] flex-shrink-0 bg-gray-100" />
      <div className="flex gap-2">
        <Button
          icon={<TrashSimple className="text-lg" weight="bold" />}
          onClick={handleEdit}
          size="middle"
          type="link"
        />
        <Button
          danger
          icon={<PencilSimple className="text-lg" weight="bold" />}
          onClick={handleRemoveLink}
          size="middle"
          type="link"
        />
      </div>
    </BubbleMenu>
  )
}
